import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {createRequestOption, createRequestBody} from '../../shared/util';
import {environment} from '../../../environments/environment';
import { map } from 'rxjs/operators';

type EntityResponseType = HttpResponse<any>;
type EntityArrayResponseType = HttpResponse<any[]>;

@Injectable({ providedIn: 'root' })
export class UsersService {
  public resourceUrl = environment.SERVER_API_URL;

  constructor(protected http: HttpClient) {}
  getproductFilter(req) {
    const options = createRequestOption(req);
    return this.http.get(this.resourceUrl + 'res/product/filter', {observe: 'response' });
  }
  queryUsers(req): Observable<EntityArrayResponseType> {
    const options = createRequestBody(req);
    return this.http.post<any[]>(this.resourceUrl + 'api/user/list/', options , { observe: 'response' });
  }
  queryInvestors(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any[]>(this.resourceUrl + 'investor', { params: options, observe: 'response' });
  }
  querySales(req): Observable<EntityArrayResponseType> {
    const options = createRequestBody(req);
    return this.http.get<any[]>(this.resourceUrl + 'api/admin/', { params: options, observe: 'response' });
  }
  querySIPRegisters(body?: any): Observable<EntityArrayResponseType> {
    return this.http.post<any[]>(this.resourceUrl + 'api/userAutomaticInvestmentRegister/list/', body, { observe: 'response' });
  }
  queryStatusCRM(req): Observable<EntityArrayResponseType> {
    const options = createRequestBody(req);
    return this.http.get<any[]>(this.resourceUrl + 'api/crmStatus/', { observe: 'response' });
  }
  queryTransactions(req): Observable<EntityArrayResponseType> {
    const options = createRequestBody(req);
    return this.http.post<any[]>(this.resourceUrl + 'order/list/', options , { observe: 'response' });
  }
  queryOrderPending(req): Observable<EntityArrayResponseType> {
    const options = createRequestBody(req);
    return this.http.post<any[]>(this.resourceUrl + 'order/pending/filter', options , { observe: 'response' });
  }
  queryTransactionHistory(req): Observable<EntityArrayResponseType> {
    const options = createRequestBody(req);
    return this.http.post<any[]>(this.resourceUrl + 'order/transaction-history/filter', options , { observe: 'response' });
  }
  queryTransferMoney(req): Observable<EntityArrayResponseType> {
    const options = createRequestBody(req);
    return this.http.post<any[]>(this.resourceUrl + 'transferPaymentLog/filter', options , { observe: 'response' });
  }
  queryRefund(req): Observable<EntityArrayResponseType> {
    const options = createRequestBody(req);
    return this.http.post<any[]>(this.resourceUrl + 'refund-request/filter', options , { observe: 'response' });
  }
  createOrderRefund(body) {
    return this.http.post(this.resourceUrl + 'refund-request/create', body , { observe: 'response' });
  }
  updateOrderRefund(body) {
    return this.http.post(this.resourceUrl + 'refund-request/' + body.id, body , { observe: 'response' });
  }
  addSignOrderRefund(body) {
    return this.http.post(this.resourceUrl + 'refund-request/add-agent-sign-contract', body , { observe: 'response' });
  }
  updateTransaction(body) {
    return this.http.put(this.resourceUrl + 'order/orderCrmBatch/', body , { observe: 'response' });
  }
  editInvestor(body) {
    return this.http.put(this.resourceUrl + `api/userCrm/${body.userId}`, body , { observe: 'response' });
  }
  assignResponsibleUser(body) {
    return this.http.put(this.resourceUrl + `api/userCrmBatch/`, body , { observe: 'response' });
  }
  deleteNoteInvestor(userId) {
    return this.http.delete(this.resourceUrl + `api/userNote/${userId}`, { observe: 'response' });
  }
  queryLocation(req?: any) {
    const options = createRequestOption(req);
    return this.http.get(this.resourceUrl + 'api/dataProvince/', { params: options, observe: 'response' })
    .pipe(map((res: any) => {
      const result = res.body.data;
      return result;
    }));
  }
  getStatistic() {
    return this.http.get(this.resourceUrl + 'stats/crm-statistics/', {observe: 'response' });
  }
  downloadFile(id) {
    return this.http.get(this.resourceUrl + `api/user/${id}/downloadContract/`, { responseType:'blob', observe: 'response' });
  }
  getAllResource(req) {
    const options = createRequestOption(req);
    return this.http.get(this.resourceUrl + 'res/all', {observe: 'response' });
  }
  uploadInvestorSupport(body) {
    return this.http.put(this.resourceUrl + `api/userCrm/support-status/change/${body.userId}`, body , { observe: 'response' });
  }
  queryListSupport(req): Observable<EntityArrayResponseType> {
    req.isCheckSupportStatus = true
    const options = createRequestBody(req);
    return this.http.post<any[]>(this.resourceUrl + 'api/user/list-support/', options , { observe: 'response' });
  }
  queryListTrackingOTP(req): Observable<EntityArrayResponseType> {
    const options = createRequestBody(req);
    return this.http.post<any[]>(this.resourceUrl + 'otp-log/list/', options , { observe: 'response' });
  }
  queryListLockPhone(req): Observable<EntityArrayResponseType> {
    const options = createRequestBody(req);
    return this.http.post<any[]>(this.resourceUrl + 'phone-lock/list/', options , { observe: 'response' });
  }
  querySupportStatusSummary(req): Observable<EntityArrayResponseType> {
    req.isCheckSupportStatus = true
    const options = createRequestBody(req);
    return this.http.post<any[]>(this.resourceUrl + 'api/user/list-support/summary', options , { observe: 'response' });
  }
  queryForeignInvestorSummary(req): Observable<EntityArrayResponseType> {
    req.isCheckSupportStatus = true
    const options = createRequestBody(req);
    return this.http.post<any[]>(this.resourceUrl + 'api/users/foreign/unassigned/summary', options , { observe: 'response' });
  }
  querySipStatusList(req): Observable<EntityArrayResponseType> {
    const options = createRequestBody(req);
    return this.http.post<any[]>(this.resourceUrl + 'api/sip/pending/detail/filter', options , { observe: 'response' });
  }
  queryListUserSegment(req) {
    const options = createRequestBody(req);
    return this.http.get(this.resourceUrl + 'stats/user-segment', { params: options, observe: 'response' });
  }
  queryListCSCustomer(req) {
    const options = createRequestBody(req);
    return this.http.post(this.resourceUrl + 'api/user-feedback/filter', options, { observe: 'response' });
  }
  queryListCSAdmin(req) {
    const options = createRequestBody(req);
    return this.http.get(this.resourceUrl + 'api/user-feedback/statistics/admin-customer-care', { params: options, observe: 'response' });
  }
  queryFeedbackStatistic(body) {
    return this.http.post(this.resourceUrl + 'api/user-feedback/statistics/by-feedback-type', body);
  }
  updateFeedbackStatistic(body) {
    return this.http.post(this.resourceUrl + 'api/user-feedback/' + body.id, body);
  }
  sendEmailFeedbackStatistic(body) {
    return this.http.post(this.resourceUrl + 'api/user-feedback/send-mail/' + body.id, body);
  }
  queryListUserReward(req) {
    const options = createRequestBody(req);
    return this.http.post(this.resourceUrl + 'wallet-reward/filter', options, { observe: 'response' });
  }
  statisticRedemption(req) {
    const options = createRequestBody(req);
    return this.http.post(this.resourceUrl + 'stats/stats-holding-time-order', options);
  }
  statisticFirstBuyTransaction() {
    return this.http.get(this.resourceUrl + 'stats/stats-first-order-by-range-age');
  }
  statisticShareTarget() {
    return this.http.get(this.resourceUrl + 'user-social-share/summary');
  }
  queryListShareTarget(req) {
    const options = createRequestBody(req);
    return this.http.post(this.resourceUrl + 'user-social-share/filter', options, { observe: 'response' });
  }
  approveShareTarget(body) {
    return this.http.post(this.resourceUrl + 'user-social-share/confirm-share-goal/' + body.id, body, { observe: 'response' });
  }
  remindPublic(body) {
    const options = createRequestOption(body);
    return this.http.post(this.resourceUrl + 'user-social-share/remind-share/' + body.id, body, {  params: options, observe: 'response' });
  }
  getInvestmentProfile(body) {
    return this.http.post(this.resourceUrl + 'investmentProfile/list/', body, {observe: 'response' });
  }
  unlockPhone(body) {
    return this.http.post(this.resourceUrl + 'phone-lock/unlock/', body, {observe: 'response' });
  }
}
